import { useParams } from "react-router";
import { useDocumentTypes } from "@/lib/hooks/use-product-documents";
import { ProductDocumentTypesTable } from "./product-document-types-table";

export default function ProductDocumentsPage() {
  const { id } = useParams<{ id: string }>();
  const { documentTypes } = useDocumentTypes(id!);

  return <ProductDocumentTypesTable portfolioCollectionId={id!} documentTypes={documentTypes} />;
}
